import { PaymentState } from './payment-state';

export class OrderPaymentRefundResponse {
    public transactionID: string;
    public errorCode: string;
    public errorText: string;
    public paymentState: PaymentState;
}
